import { initialState } from './selectors';
import { WORK_ASSIGNMENT_HIDE } from './actions';

export default (state, action) => {
  const { type, payload } = action || {};
  const currentState = state || initialState;

  switch (type) {
    case WORK_ASSIGNMENT_HIDE:
      return {
        ...currentState,
        hiddenAssignment: payload,
      };
    default:
      return currentState;
  }
};
